import {Row, Col, Button, Checkbox, Form, Input, Alert} from "antd";
import React, {useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {requestAdminLogin, resetLoginChallenge, verifyAdminOtp} from "../../redux/slice/accountSlice";
import {AppDispatch, RootState} from "../../redux/store";
import {COLORS} from "../../designSystem";

type FieldType = {
    email?: string;
    password?: string;
    code?: string;
    remember?: string;
};

const Login = () => {
    let navigate = useNavigate();

    const dispatch: AppDispatch = useDispatch();
    const {isAuthenticated, loading, error, otpEmail, otpExpiresAt, requiresTwoFactor} = useSelector((state: RootState) => state.account);
    const [email, setEmail] = useState("");

    const onFinish = async (values: any) => {
        setEmail(values.email);
        await dispatch(requestAdminLogin({email: values.email, password: values.password}));
    };

    const onOtpFinish = async (values: any) => {
        await dispatch(verifyAdminOtp({email: otpEmail || email, code: values.code}));
    };

    useEffect(() => {
        if (isAuthenticated) {
            navigate("/");
        }
    }, [isAuthenticated, navigate]);

    useEffect(() => {
        return () => {
            dispatch(resetLoginChallenge());
        };
    }, [dispatch]);

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return (
        <Row>
            <Col
                md={10}
                lg={10}
                className="flex bg-no-repeat bg-cover h-screen"
                style={{
                    backgroundImage:
                        "url(https://images.pexels.com/photos/6446708/pexels-photo-6446708.jpeg)",
                }}
            ></Col>

            <Col md={14} lg={14} className="flex justify-center">
                <div className="w-full md:w-3/4 md:p-10 p-4">
                    <div className="mt-6 text-xl font-bold tracking-tight" style={{color: COLORS.brand}}>Payhive Admin</div>
                    <div className="mt-20">
                        <div className={"mb-10"}>
                            <h2 className="text-bold text-3xl">{requiresTwoFactor ? "Verify Login" : "Log In"}</h2>
                            <span>
                                {requiresTwoFactor
                                    ? `Enter the OTP sent to ${otpEmail}.`
                                    : "We are glad you are here again."}
                            </span>
                            {requiresTwoFactor && otpExpiresAt && (
                                <p className="mt-2 text-sm text-gray-500">
                                    Code expires at {new Date(otpExpiresAt).toLocaleString()}.
                                </p>
                            )}
                        </div>
                        {error && <Alert className="mb-6" type="error" showIcon title={error}/>}
                        {!requiresTwoFactor ? <Form
                            name="basic"
                            initialValues={{
                                remember: true,
                            }}
                            layout="vertical"
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            autoComplete="off"
                        >
                            <Form.Item<FieldType>
                                label="Email Address"
                                name="email"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please input your email!",
                                    },
                                ]}
                            >
                                <Input size="large"/>
                            </Form.Item>

                            <Form.Item<FieldType>
                                label="Password"
                                name="password"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please input your password!",
                                    },
                                ]}
                            >
                                <Input.Password size="large"/>
                            </Form.Item>

                            <Row>
                                <Col md={14}>
                                    <Form.Item<FieldType>
                                        name="remember"
                                        valuePropName="checked"
                                        wrapperCol={{
                                            span: 12,
                                        }}
                                    >
                                        <Checkbox>Remember me</Checkbox>
                                    </Form.Item>
                                </Col>

                                <Col md={10} className="text-right">
                                    <Link to="/forgotpassword">
                                        <Button type="link">Forgot Password</Button>
                                    </Link>
                                </Col>
                            </Row>

                            <Form.Item
                                wrapperCol={{
                                    span: 24,
                                }}
                            >
                                <Button htmlType="submit" block type="primary" size="large" loading={loading}>
                                    Login
                                </Button>
                            </Form.Item>
                        </Form> : <Form
                            name="otp"
                            layout="vertical"
                            onFinish={onOtpFinish}
                            autoComplete="off"
                        >
                            <Form.Item<FieldType>
                                label="One-time password"
                                name="code"
                                rules={[{required: true, message: "Please input the OTP!"}]}
                            >
                                <Input size="large" maxLength={8}/>
                            </Form.Item>
                            <Form.Item>
                                <Button htmlType="submit" block type="primary" size="large" loading={loading}>
                                    Verify OTP
                                </Button>
                            </Form.Item>
                            <Button block type="link" onClick={() => dispatch(resetLoginChallenge())}>
                                Use a different email
                            </Button>
                        </Form>}
                    </div>
                </div>
            </Col>
        </Row>
    );
};

export default Login;
